export function isMetaInAppBrowser() {
	if (typeof navigator === "undefined") return false;
	return /Instagram|FBAN|FBAV|FB_IAB|FB4A|FBIOS/i.test(
		navigator.userAgent || "",
	);
}

export function getExternalBrowserHref() {
	if (typeof window === "undefined") return "";
	const host = window.location.host;
	const path = window.location.pathname + window.location.search;
	if (/Android/i.test(navigator.userAgent || "")) {
		return (
			"intent://" +
			host +
			path +
			"#Intent;scheme=https;package=com.android.chrome;end"
		);
	}
	return window.location.href;
}
